<script>
    import { uniqueArray } from "@/utils";
    import { lookbook } from "@xd/lookbook";
    import LookbookTemplate from "@xd/components/LookbookTemplate";

    export default {
        name: "LookbookContent",
        components: { LookbookTemplate },
        data() {
            return {
                products: [],
            };
        },
        mounted() {
            this.getProducts();
        },
        computed: {
            templates() {
                return lookbook;
            },
        },
        methods: {
            getProducts() {
                const productsIds = this.templates
                    .map((template) => template.productId)
                    .filter(uniqueArray);

                this.$store.productsApi
                    .getProductsListById({
                        listIds: productsIds,
                        filterAvailable: false,
                    })
                    .then(({ items }) => {
                        this.products = items;
                    });
            },
        },
    };
</script>

<template>
    <div class="lookbook-content">
        <div class="l-container">
            <lookbook-template
                v-for="(template, index) in templates"
                :key="index"
                :name="template.name"
                :product-id="template.productId"
                :offer-id="template.offerId"
                :type="template.type"
                :dot="template.dot"
                :products="products"
            ></lookbook-template>
        </div>
    </div>
</template>

<style lang="scss">
    .lookbook-content {
        margin: -24px 0 -25px;
        overflow: hidden;
        @include bp($bp-desktop-sm) {
            margin: -74px 0 0;
            padding-bottom: 68px;
        }
    }
</style>
